export const hr = {
    seo: {
        title: 'MyCarCosts | Ultimate Car Expense Tracker & Repair Analysis',
        description: 'Track car maintenance, expenses, and history. Use our AI-powered repair vs sell analyzer to make data-driven decisions about your vehicle.'
    },
    common: {
        back: "Natrag",
        save: "Spremi",
        saved: "Spremлено",
        cancel: "Otkaži",
        close: "Zatvori",
        accessDenied: "Pristup odbijen",
        noExportPermission: "Nemate dopuštenje za izvoz ovih podataka o automobilu.",
        delete: "Izbriši",
        downgrade: "Smanji",
        downgradeConfirm: "Jeste li sigurni da želite smanjiti na besplatan plan?",
        edit: "Uredi",
        loading: "Učitavanje...",
        confirm: "Potvrdi",
        processing: "Obrada...",
        history: "Povijest",
        currentCar: "Trenutni Auto",
        purchasedCarTitle: "Kupnja Automobila",
        initialCost: "Početni Trošak",
        done: "Gotovo",
        ok: "U redu",
        error: "Greška",
        errorSaving: "Greška pri spremanju podataka",
        mandatoryFieldsError: "Molimo ispunite sva obavezna polja ispravno.",
        search: "Pretraži",
        milesShort: "mi",
        kmShort: "km",
        invalidEmail: "Neispravan format e-pošte",
        today: "Danas",
        car: "Auto",
        all: "Sve",
        deleteConfirm: "Izbriši",
        unsavedChangesTitle: "Ne spremljene promjene",
        unsavedChangesMessage: "Želite li spremiti promjene prije odlaska?",
        dontSave: "Ne spremi",
        additionalOptions: "Dodatne opcije",
        add: "Dodaj",
        fileTooLarge: "Datoteka je prevelika. Maksimalna veličina je {limit} MB.",
        storageFull: "Prekoračen limit pohrane. Maksimalna pohrana je {limit} MB.",
        dailyUploadLimit: "Dnevni limit prijenosa dostignut ({limit} datoteka/dan). Pokušajte ponovno sutra.",
        hourlyUploadLimit: "Satni limit prijenosa dostignut ({limit} datoteka/sat). Pokušajte ponovno za sat vremena.",
        fileCountLimit: "Maksimalno {limit} datoteka dopušteno po stavci.",
        emailParseLimitReached: "Dostignut limit obrade e-pošte. Molimo nadogradite svoj plan ili obradite ručno.",
        emailLimitText: "Dostignut limit obrade e-pošte.",
        monthlyEmailScans: "Mjesečna skeniranja e-pošte",
        lifetimeEmailScans: "Cjelokupna skeniranja e-pošte",
        monthlyFileScans: "Mjesečna skeniranja računa",
        lifetimeFileScans: "Cjelokupna skeniranja računa",
        fileLimitText: "Dostignut limit skeniranja računa.",
        planFreeTier: "Besplatni plan",
        planProTier: "Pro plan",
        uploadFailed: "Prijenos nije uspio",
        attachments: "Privitci",
        limitsAndUsage: "Limiti i Korištenje",
        addresses: "adrese",
        emailCopied: "Adresa e-pošte kopirana!",
        units: {
            liters: "l",
            gallons: "gal",
            kilometers: "km",
            miles: "mi",
        },
        included: "Uključeno",
        proOnly: "Samo PRO",
        month: "mj",
        openInNewTab: "Otvorite u novoj kartici",
        menu: "Izbornik",
        home: "Početna",
        monthsShort: {
            0: "Sij",
            1: "Vel",
            2: "Ožu",
            3: "Tra",
            4: "Svi",
            5: "Lip",
            6: "Srp",
            7: "Kol",
            8: "Ruj",
            9: "Lis",
            10: "Stu",
            11: "Pro",
        },
    },
    carMetadata: {
        bodyType: "Tip Karoserije",
        drivetrain: "Pogon",
        transmission: "Mjenjač",
        bodyTypes: {
            sedan: "Limuzina",
            hatchback: "Hatchback",
            wagon: "Kombi (Estate)",
            suv: "SUV",
            crossover: "Crossover",
            coupe: "Kupe",
            convertible: "Kabriolet",
            pickup: "Pickup",
            van: "Van / Minivan",
            commercial: "Komercijalno",
            other: "Ostalo",
            not_specified: "-",
        },
        drivetrains: {
            not_specified: "-",
            fwd: "FWD",
            rwd: "RWD",
            awd: "AWD / 4x4",
            other: "Ostalo",
        },
        transmissions: {
            not_specified: "-",
            manual: "Ručno",
            automatic: "Automatski",
            cvt: "CVT",
            other: "Ostalo",
        },
        otherLabel: "Ostalo (navedite)",
        mileageLabel: "Kilometraža",
    },
    auth: {
        welcome: "Dobrodošli",
        welcomeBack: "Ponovno dobrodošli",
        signIn: "Prijavite se",
        signInWithGoogle: "Prijavite se s Googleom",
        signOut: "Odjavite se",
        magicLinkDesc: "Dobijte čarobnu vezu u svoju e-poštu",
        magicLinkSent: "Čarobna veza poslana!",
        magicLinkCheckEmail: "Provjerite svoju e-poštu i kliknite na vezu za prijavu.",
        emailAddress: "Adresa e-pošte",
        getMagicLink: "Dobijte čarobnu vezu",
        sending: "Šaljem...",
        linkSent: "Veza poslana",
        orContinueWith: "Ili nastavite s",
        googleAccount: "Google račun",
        newUserNote: "Novajlija? Vaš račun će biti automatski kreiran prilikom vaše prve uspješne prijave.",
        magicLinkError: "Slanje čarobne veze nije uspjelo. Molimo provjerite svoju e-poštu i pokušajte ponovno.",
        genericError: "Došlo je do greške. Molimo pokušajte ponovno.",
        projectDescription: "Pratite troškove automobila, održavanje i povijest na jednom mjestu.",
        loginError: "Nije moguće prijaviti se",
        loggingIn: "Prijavljivanje...",
        authenticating: "Autentifikacija...",
        authenticatingDesc: "Molimo pričekajte dok osiguravamo vašu sesiju.",
    },
    settings: {
        title: "Postavke",
        systemPreferences: "Sistemske postavke",
        appSettings: "Postavke aplikacije",
        dangerZone: "Opasna zona",
        theme: "Tema",
        language: "Jezik sučelja",
        currency: "Valuta",
        units: "Jedinice",
        distanceUnit: "Jedinica udaljenosti",
        volumeUnit: "Jedinica volumena",
        expenseTypes: "Tipovi troškova",
        expenseTypesDesc: "Upravljanje kategorijama",
        categories: "Kategorije",
        exportData: "Izvezi podatke",
        exportDesc: "Preuzmite sveobuhvatan CSV",
        importData: "Uvezi podatke",
        importDesc: "Vrati iz CSV sigurnosne kopije",
        deleteAccount: "Izbriši račun",
        deleteAccountDesc: "Trajno ukloni sve podatke",
        enableSync: "Omogući sinkronizaciju",
        enableSyncDesc: "Sinkroniziraj podatke između uređaja",
        account: "Račun",
        accountPlan: "Plan računa",
        carsUsage: "Automobili",
        carsLimitReached: "Dostignut limit automobila",
        storageSize: "Veličina pohrane",
        emailScans: "Skeneri e-pošte",
        fileScans: "Skeneri računa",
        plans: "Planovi",
        currentlyPlan: "Trenutno",
        upgradePlan: "Nadogradi",
        manageSubscription: "Upravljanje pretplatom",
        nextPayment: "Sljedeće plaćanje",
        endsOn: "Završava",
        adminConsole: "Administratorska konzola",
        systemControl: "Kontrola sustava",
        customCategories: "Prilagođene kategorije i oznake",
        interfaceTheme: "Tema sučelja",
        light: "Svijetla",
        dark: "Tamna",
        timezone: "Vremenska zona",
        timezoneDesc: "Koristi se za zakazane e-mail podsjetnike",
        timeFormat: "Format vremena",
        timeFormat24h: "24-satni (14:30)",
        timeFormat12h: "12-satni (2:30 PM)",
        kilometers: "kilometri (km)",
        miles: "milje (mi)",
        liters: "litara (l)",
        gallons: "galoni (gal)",
        accountManagement: "Upravljanje računom",
        contactUs: "Kontaktirajte nas",
        contactDesc: "Za prijedloge, zahtjeve za funkcijama i pitanja",
        logOut: "Odjavi se",
        logOutConfirmTitle: "Odjavi se",
        logOutConfirmMessage: "Jeste li sigurni da se želite odjaviti sa svog računa?",
        keepAccount: "Zadrži račun",
        deleteAccountConfirmTitle: "Izbriši račun",
        deleteAccountConfirmMessage: "Jeste li sigurni da želite trajno izbrisati svoj račun i sve povezane podatke o automobilu? Ova radnja se ne može poništiti.",
        deletePermanently: "Trajno izbriši",
        deleting: "Brišem...",
        contactSupport: "Kontaktirajte podršku",
        messageSent: "Poruka poslana!",
        feedbackThanks: "Hvala na vašem povratnom informaciji. Cijenimo vaš doprinos i istražit ćemo to.",
        backToSettings: "Povratak na postavke",
        subjectLabel: "Predmet",
        messageLabel: "Poruka",
        subjectPlaceholder: "O čemu se radi?",
        messagePlaceholder: "Recite nam o svom prijedlogu, zahtjevu za funkcijom ili pitanju...",
        enterSubjectAlert: "Molimo unesite predmet",
        enterMessageAlert: "Molimo unesite poruku",
        sendFailedAlert: "Slanje poruke nije uspjelo. Molimo pokušajte ponovno kasnije.",
    },
    export: {
        title: "Izvezi podatke",
        generatePDF: "Generiraj PDF",
        carInformation: "Informacije o automobilu",
        editInfo: "Uredite informacije u nastavku kako biste prilagodili svoj izvoz",
        editInfoHint: "Možete ukloniti ili izmijeniti bilo koja polja koja ne želite uključiti",
        filters: "Filteri",
        expenseTypes: "Tipovi troškova",
        includeNotes: "Uključi bilješke",
        includeImages: "Uključi datoteke",
        hideDisabled: "Sakrij onemogućene stavke",
        itemsCount: "{total} stavki, {selected} odabranih",
        selectAll: "Odaberi sve",
        deselectAll: "Poništi odabir svih",
        expenses: "Troškovi",
        notes: "Bilješke",
        spareParts: "Rezervni dijelovi",
        images: "Slike",
        files: "Datoteke",
        summary: "Sažetak",
        totalExpenses: "Ukupni troškovi",
        totalItems: "Ukupno stavki",
        generatedOn: "Generirano na",
        noItemsSelected: "Nema stavki odabranih za izvoz",
        noItemsAvailable: "Nema stavki dostupnih za izvoz",
        generating: "Generiram PDF...",
        downloadPDF: "Preuzmi PDF",
        pdfFileName: "{carName}_izvoz_{date}.pdf",
        reportTitle: "Izvještaj o troškovima automobila",
        exportButton: "Izvezi",
        generateCSV: "Generiraj CSV",
        formatSelectorTitle: "Odaberite format",
        formatSelectorMsg: "Molimo odaberite format izvoza",
        proFeatureExportTitle: "Pro značajka: Izvoz podataka",
        proFeatureExportDesc: "Nadogradite na PRO za izvoz povijesti vašeg automobila u PDF.",
        exportRestrictedPopup: "Izvoz podataka dostupan je samo za Pro korisnike.",
        allTypes: "Svi tipovi",
        statistics: "Statistika",
        driven: "Vožnja",
        since: "Od",
        averageCost: "Prosječni trošak",
        perKm: "po km",
        perMile: "po milji",
        period: "Razdoblje",
        dateFrom: "Od",
        dateTo: "Do",
        allTime: "Očisti filter",
        periodHint: "Ako nije odabrano razdoblje — prikazuju se svi troškovi",
        noExpenses: "Nema troškova koji odgovaraju filtrima",
        expensesSection: "Troškovi",
        attachmentsSection: "Privitci",
        imagesCount: "{count} slika",
        pdfsCount: "{count} PDF-ova",
        includeParts: "Uključi rezervne dijelove",
        pageLabel: "Stranica",
    },
    expenses: {
        title: "Troškovi",
        newExpense: "Novi trošak",
        editExpense: "Uredi trošak",
        openExpense: "Otvorite unos troška",
        details: "Detalji troška",
        selectType: "Odaberite tip",
        selectTypePlaceholder: "Odaberite tip troška...",
        shortDescriptionPlaceholder: "Kratak opis...",
        expenseTitle: "Naslov",
        logEntryTitleLabel: "Naslov zapisa (Opcionalno)",
        defaultTitlePlaceholder: "Zadani naslov - {type}",
        autoTitlePlaceholder: "Bit će automatski ispunjeno na temelju odabranih tipova",
        carDataTitle: "Podaci o automobilu",
        defaultTitlePrefix: "Zadani naslov će biti -",
        addAnother: "Dodaj još jedan tip troška",
        addAnotherHint: "Ako ovaj zapis uključuje više tipova troškova, možete ih sve dodati ovdje kako biste osigurali točnu statistiku.",
        carValueDescription: "Procijenjena tržišna vrijednost automobila u ovom trenutku.",
        type: "Tip",
        date: "Datum",
        amount: "Iznos",
        totalAmount: "Ukupno",
        splitCosts: "Podijeliti troškove?",
        combineCosts: "Kombiniraj troškove",
        amountWork: "Rad",
        amountParts: "Dijelovi",
        mileage: "Kilometraža",
        carValue: "Vrijednost automobila",
        description: "Opis",
        detailedDescription: "Detaljan opis",
        electricity: "Električna energija",
        fuelType: "Tip goriva",
        fuelTypeOptions: {
            petrol: "Benzin",
            diesel: "Dizel",
            lpg: "LPG",
            electricity: "Električna energija",
        },
        carData: "Podaci o automobilu",
        images: "Datoteke",
        addImages: "Dodaj datoteke",
        addImagesPDFs: "Dodaj slike ili PDF-ove",
        deleteExpense: "Izbriši trošak",
        deleteConfirm: "Jeste li sigurni da želite izbrisati ovaj trošak?",
        saveSuccess: "Trošak je uspješno spremljen",
        thisExpense: "Ovaj trošak",
        stats: {
            annual: "Godišnje",
            allTime: "Sveukupno",
            avgMonth: "Prosjek/Mjesec",
            costPer: "Trošak/",
            noExpenses: "Još nema troškova",
            dragToReorder: "Povucite za promjenu reda",
        },
        expensesFound: "Stvoreno",
        noExpensesFound: "Nema pronađenih troškova.",
        noDescription: "Nema opisa",
        imagesCount: "Slike ({count})",
        deleteImageTitle: "Izbriši sliku",
        deleteImageConfirm: "Jeste li sigurni da želite izbrisati ovu sliku? Ova radnja se ne može poništiti.",
        typeLabels: {
            fuel: "Gorivo",
            car_wash: "Pranje",
            repairs: "Popravci",
            maintenance: "Održavanje",
            parts: "Rezervni dijelovi",
            insurance: "Osiguranje",
            inspection: "Inspekcija",
            tyres: "Gume",
            parking: "Parkiranje",
            electricity: "Električna energija",
            taxes: "Porezi",
            other: "Ostalo",
            info: "Informacije",
            service_maintenance: "Održavanje",
            service_repair: "Popravak",
            service_tuning: "Tuning",
        },
        serviceGroup: {
            name: "Servis",
            selectSubtype: "Odaberite tip usluge",
            maintenance: "Održavanje",
            repair: "Popravak",
            tuning: "Tuning",
        },
    },
    repeatingExpenses: {
        title: "Ponovljeni Trošak",
        repeatToggle: "Ponovi ovaj trošak",
        repeatFrequency: "Učestalost",
        monthly: "Mjesečno",
        startDate: "Datum početka",
        nextDate: "Sljedeći unos će biti generiran",
        endDate: "Datum završetka",
        noEndDate: "Nema datuma završetka",
        copyOptions: "Opcije kopiranja",
        copyTitle: "Kopiraj naslov zapisa",
        copyLocation: "Kopiraj lokaciju",
        copyDescription: "Kopiraj opis",
        active: "Aktivno",
        status: "Status",
        managedByRepeat: "Ovaj trošak je dio ponovljenog niza.",
        placeholder: "Ovdje možete postaviti automatsko ponavljanje za ovaj trošak ako se redovito pojavljuje s istim iznosom.",
        deleteRepeat: "Izbriši ponavljanje",
        deleteRepeatConfirm: "Jeste li sigurni da želite prekinuti i izbrisati ovaj ponovljeni niz? Budući unosi neće biti generirani. Prošli unosi će ostati.",
        relatedEntries: "Unosi u ovom nizu",
        stopRepeat: "Prekini ponavljanje",
        isRepeating: "Ponavlja se",
        noTerm: "Neodređeno",
        until: "Posljednji unos će biti generiran",
        summaryCopy: "Sustav će kopirati",
        simulate: "Simuliraj generiranje sljedećeg unosa",
        simulateSuccess: "Uspješno simulirano generiranje sljedećeg unosa",
        simulateNoDate: "Nema više datuma za generiranje (došao je kraj datuma)",
    },
    onboarding: {
        title: "Postavljanje profila",
        welcome: "Dobrodošli!",
        subtitle: "Prilagodite svoje vozačko iskustvo.",
        currency: "Valuta",
        preferredCurrency: "Preferirana valuta",
        distUnit: "Jedinica udaljenosti",
        volUnit: "Jedinica volumena",
        complete: "Završi postavljanje",
    },
    cars: {
        unitChangeWarningTitle: "Upozorenje na promjenu jedinica",
        unitChangeWarningMessage: "Promjena ovih jedinica neće konvertirati vaše postojeće podatke. Svi povijesni zapisi ostat će točno onakvi kakvi su uneseni.",
        unitChangeWarningConfirm: "Razumijem",
        title: "Garaža",
        carAdmins: "Administratori automobila",
        sharedWithMe: "Dijeljeno sa mnom",
        manageAdmins: "Upravljanje administratorima",
        adminEmail: "Email administratora",
        addAdmin: "Dodaj administratora",
        addAdminPlaceholder: "npr. prijatelj@email.com",
        removeAdmin: "Ukloni",
        removeAdminConfirm: "Jeste li sigurni da želite ukloniti ovog administratora?",
        adminAdded: "Administrator dodan",
        adminRemoved: "Administrator uklonjen",
        removeMyAccess: "Ukloni moj pristup",
        removeMyAccessConfirm: "Jeste li sigurni da želite odustati od pristupa ovom automobilu?",
        myAccessRemoved: "Pristup uklonjen",
        noAdminsYet: "Još nisu dodani administratori.",
        adminInfoText: "Administratori mogu dodavati i uređivati troškove, bilješke i rezervne dijelove, ali ne mogu brisati sam automobil.",
        newCar: "Dodaj Automobil",
        carNotFound: "Automobil Nije Pronađen",
        carNotFoundDesc: "Traženi automobil ne postoji ili nemate pristup.",
        accessDenied: "Pristup Odbijen",
        accessDeniedDesc: "Ovaj automobil je privatni i nije javno dostupan.",
        backToHome: "Povratak na Početnu",
        adminRestricted: "Pristup Ograničen",
        adminRestrictedDesc: "Samo ovlašteni administratori mogu pristupiti ovoj konzoli. Molimo vas da se vratite na glavnu aplikaciju.",
        returnHome: "Povratak na Početnu",
        editCar: "Uredi Automobil",
        name: "Ime Automobila",
        model: "Model",
        year: "Godina",
        plate: "Broj Registracije",
        vin: "VIN Broj",
        mileage: "Trenutna Kilometraža",
        initialMileage: "Početna Kilometraža",
        engineType: "Tip Motora",
        tapToChangeIcon: "Dodirnite za promjenu ikone",
        chooseIcon: "Odaberite Ikonu",
        imageTab: "Slika",
        iconTab: "Ikona",
        chooseColor: "Odaberite Boju",
        chooseEmoji: "Odaberite Emoji",
        uploadImage: "Otpremi Sliku",
        clickToBrowse: "Kliknite za pregled datoteka",
        currentCarIcon: "Trenutna ikona automobila",
        changeImage: "Promijeni Sliku",
        zoom: "Povećaj",
        rotate: "Rotiraj",
        removeChangeImage: "Ukloni / Promijeni Sliku",
        selectIcon: "Odaberi Ikonu",
        cropAndSave: "Izreži i Spremi",
        displayName: "Prikazano Ime",
        displayNamePlaceholder: "npr. Moj Vikend Automobil",
        makeLabel: "Proizvođač *",
        modelLabel: "Model *",
        yearLabel: "Godina *",
        fuelTypeLabel: "Tip Goriva *",
        licensePlateLabel: "Registracijska Oznaka",
        vinLabel: "VIN",
        notesLabel: "Bilješke",
        notesPlaceholder: "npr. 1.6 TDI, 85kW, 1588cc, baterija 62kWh, AWD, itd.",
        publicAccess: "Učini automobil javno dostupnim",
        publicAccessDesc: "Drugi mogu vidjeti ovaj automobil putem dijeljenog linka",
        shareLocations: "Dopusti pregled dodanih lokacija",
        shareLocationsDesc: "Omogućite ovo kako biste učinili lokacije automobila vidljivima u javnom prikazu",
        deleteCar: "Izbriši Automobil",
        deleteCarTitle: "Izbriši Automobil",
        deleteCarConfirm: "Jeste li sigurni da želite izbrisati '{name}'? Ova radnja se ne može poništiti.",
        noCars: "Nema automobila u vašoj garaži",
        addFirstCarNote: "Započnite svoje putovanje dodavanjem svog prvog vozila za praćenje troškova.",
        addVehicle: "Dodaj Vozilo",
        myVehicles: "Moja Vozila",
        favorites: "Omiljeni",
        deleteConfirm: "Jeste li sigurni da želite izbrisati ovaj automobil? Svi povezani troškovi će biti izbrisani.",
        deleteFailed: "Neuspješno brisanje automobila",
        saveFailed: "Neuspješno spremanje podataka o automobilu",
        adminActions: "Administratorske Radnje",
        importCsv: "Uvezi CSV",
        clearData: "Obriši Podatke",
        distanceUnitLabel: "Jedinca Udaljenosti",
        volumeUnitLabel: "Jedinca Zapremine",
        currencyLabel: "Valuta",
        boughtAt: "Datum Kupnje",
        purchasePrice: "Cijena Kupnje",
        purchaseMileage: "Kilometraža pri Kupnji",
        createPurchaseRecord: "Automatski kreiraj zapis o povijesti kupnje",
        makePlaceholder: "npr. BMW",
        modelPlaceholder: "npr. X5",
        platePlaceholder: "npr. AB-1234",
        vinPlaceholder: "VIN...",
        purchaseInfoNote: "Ove informacije će stvoriti inicijalni zapis 'Informacije' u vašoj povijesti s navedenim podacima.",
        availableTypes: "Dostupne Vrste",
        dragToReorder: "Povucite za promjenu reda",
        requestTypeNote: "Ako vam treba druga vrsta - ",
        requestTypeAction: "javite nam!",
        emailProcessingTitle: "Obrada E-pošte",
        emailInstructions: "Proslijedite svoje račune na adresu u nastavku. Izvuc ćemo podatke i automatski kreirati troškove.",
        recentEmails: "Primljene E-pošte",
        viewAllEmails: "PREGLEDAJ SVE ({count})",
        noEmailsReceived: "Još nisu primljene e-pošte.",
        analysisResult: "Rezultat Analize",
        vehicleInfo: "Informacije o Vozilu",
        preferences: "Postavke",
        purchaseHistory: "Povijest Kupnje",
        emailProcessing: "Obrada E-pošte",
        publicAccessTitle: "Javni Pristup",
        expenseTypesTitle: "Vrste Troškova",
        adminActionsTitle: "Administratorske Radnje",
        enterPurchaseDateAlert: "Molimo unesite datum kupnje",
        allowedSenderEmails: "Dopuštene E-pošte Pošiljatelja",
        allowedEmailsDesc: "Dodajte adrese e-pošte koje su dopuštene za slanje računa ovom automobilu. Maksimalno 5 adresa.",
        noAllowedEmails: "Nema dodanih dopuštenih e-pošta.",
        emailAlreadyAdded: "Ova e-pošta je već dopuštena za ovaj automobil.",
        maxAllowedEmailsReached: "Maksimalni broj dopuštenih e-pošta je dostignut.",
        addAllowedEmailPlaceholder: "Dodaj dopuštenu e-poštu...",
        ownerEmail: "Vlasnik",
        onlyOwner: "samo vlasnik",
        defaultAllowed: "Uvijek dopušteno",
        carLimitReachedTitle: "Dostignut Limit Automobila",
        carLimitReachedMessage: "Vaš {plan} plan dopušta {limit} automobil(a). Već imate {current}. Idite na postavke da vidite svoje limite ili nas kontaktirajte za nadogradnju.",
        carLimitGoToSettings: "Idite na Postavke",
        archivedCars: "Arhivirano",
        archiveCar: "Arhiviraj auto",
        unarchiveCar: "Poništi arhiviranje auta",
        sellDate: "Datum prodaje",
        sellPrice: "Cijena prodaje",
        sellMileage: "Kilometraža pri prodaji",
        archiveConfirm: "Jeste li sigurni da želite arhivirati ovaj auto?",
        archiveInstructions: "Arhiviranje auta znači da više nije vaš ili ga više ne održavate. Molimo navedite detalje prodaje za statistiku. Ovo će učiniti auto samo za čitanje. Polja ispod se i dalje mogu uređivati nakon toga.",
        archivedBadge: "Arhivirano",
        saleDetails: "Detalji prodaje",
        saleDetailsNote: "Detalji prodaje koriste se za statistiku. Možete ih ažurirati ako je potrebno.",
        archiveDetailsNotFillable: "Molimo ispunite sva polja da biste arhivirali auto",
        emailAddressWillBeAvailableAfterSave: "Email adresa bit će dostupna nakon spremanja auta.",
        proFeatureAdminTitle: "Pro značajka: Administratori automobila",
        proFeatureAdminDesc: "Dodajte druge korisnike koji mogu pregledavati i upravljati ovim podacima o automobilu.",
        proFeatureEmailTitle: "Pro značajka: Dodatni pošiljatelji",
        proFeatureEmailDesc: "Dodajte druge dopuštene adrese e-pošte s kojih se mogu slati računi ovom automobilu.",
        estimatedMileage: "Procijenjena kilometraža",
        summaryFrequencyLabel: "Frekvencija sažetka",
        summaryFrequencyOptions: {
            none: "Isključeno",
            monthly: "Mjesečno",
            semiAnnually: "Polugodišnje",
            annually: "Godišnje",
        },
        healthProfilePrompt: "Dovršite svoj zdravstveni profil za točnu analizu!",
    },
    fuelTypes: {
        not_specified: "-",
        petrol: "Benzin",
        diesel: "Dizel",
        hybrid: "Hibrid",
        electric: "Električni",
        lpg: "LPG",
    },
    statistics: {
        mileageTrend: "Trend kilometraže",
        title: "Statistika",
        allYears: "Sve godine",
        totalSpent: "Ukupno potrošeno",
        spentIn: "Potrošeno u {year}",
        perMonth: "mjesečno",
        overall: "ukupno",
        vsPrev12m: "vs pret. 12 mj",
        rolling12m: "Zadnjih 12 mj",
        byType: "Prema vrsti",
        byMonth: "Prema mjesecu",
        byYear: "Prema godini",
        noData: "Nema podataka za ovu godinu",
        mostExpensive: "Najskuplje",
        top: "Najbolje",
        untitled: "Bez naslova",
        assetAnalysis: "Analiza vrijednosti i troškova",
        burnNote: "* 'Ukupno trošenje' uključuje i novac potrošen i procijenjeno smanjenje vrijednosti auta.",
        carMarketValue: "Tržišna vrijednost auta",
        cumulativeCosts: "Kumulativni troškovi",
        totalBurn: "Ukupno trošenje (Troškovi + Amortizacija)",
        entries: "unosa",
        avgPrice: "Prosječna cijena",
        consumption: "Potrošnja",
        price: "Cijena",
        fuelPriceTrend: "Trend cijena goriva",
        spendingTrend: "Trend troškova",
        costPerKmTrend: "Trošak po 1 km",
        costPerMileTrend: "Trošak po 1 milji",
        serviceTrendsTitle: "Trendovi usluga",
        expensesOnMap: "Troškovi na karti",
        visitsCountLabel: "posjeta",
        locationsSummary: "Sažetak lokacija",
        locationsCountLabel: "mjesta",
        noLocationsFoundTitle: "Nema pronađenih lokacija",
        noLocationsFoundDesc: "Dodajte lokacije u svoje zapise da biste ih vidjeli na karti.",
        addMileageData: "Dodaj kilometražu",
        missingMileageInfo: "Nema dovoljno podataka za izračunavanje troška po udaljenosti. Dodajte najmanje 2 očitanja kilometraže u ovom razdoblju (ili jedno prije ovog razdoblja).",
        mileageModal: {
            title: "Dodaj nedostajuću kilometražu",
            description: "Kako bismo točno izračunali troškove po udaljenosti za {year}, trebamo znati kilometražu na početku i kraju godine.",
            startOfYear: "Početak godine (1. siječnja)",
            endOfYear: "Kraj godine (31. prosinca)",
            currentMileage: "Trenutna kilometraža",
            placeholder: "Unesite kilometražu...",
            save: "Spremi podatke",
            foundNearby: "Pronađeno u blizini ({date}): {value} {unit}",
            useExisting: "Koristi ovo",
        },
        proAnalysis: "Pro analiza",
        detailedAnalysis: "Detaljna analiza",
        upgradeToSee: "Nadogradite za pregled →",
    },
    tabs: {
        dashboard: "Nadzorna ploča",
        expenses: "Troškovi",
        stats: "Statistika",
        locations: "Lokacije",
        gallery: "Datoteke",
        parts: "Dijelovi",
        notes: "Bilješke",
        repair: "Način popravka",
        'repair-switch': "Prebacivanje automobila",
    },
    repairAnalysis: {
        title: "Analiza odluka o popravku",
        ownershipLength: "Duljina vlasništva",
        currentValue: "Trenutna vrijednost",
        valueOutdated: "Vrijednost može biti zastarjela",
        addValueToEnable: "Dodajte trenutnu vrijednost auta da omogućite analizu",
        totalInvested: "Ukupno uloženo",
        totalInvestedSub: "Cijena kupnje + popravci",
        totalExcludesFuel: "ne uključuje gorivo / struju",
        fuelLabelFuelOnly: "Ukupno gorivo",
        fuelLabelEnergyOnly: "Ukupna energija",
        fuelLabelHybrid: "Ukupno gorivo i energija",
        fuelTypeFuel: "gorivo",
        fuelTypeEnergy: "struja",
        fuelTypeHybrid: "gorivo i struja",
        fuelTotalLabel: "Ukupno gorivo/energija:",
        projectionMode: "Način projekcije",
        projectionModes: {
            lastYear: "Na temelju prošle godine",
            average: "Povijesni prosjek",
            trend: "Trend (linearno)",
        },
        brakeAssumption: "Održavanje uključuje procijenjeni trošak kočnica na 3 godine",
        repairBuffer: "Uključuje rizik od popravka temeljen na starosti",
        yearLabel: "godina",
        totalInvestedDesc: "Cijena kupnje + svi popravci",
        repairToValue: "Popravak u odnosu na vrijednost (12m)",
        repairToValueExplain: "Popravci €{cost} naspram vrijednosti auta €{value}. Ispod 20% je zdravo; iznad 50% je visok rizik.",
        ownershipPressure: "Pritisak vlasništva",
        ownershipPressureExplain: "Ukupni pritisak troškova: popravci €{cost} + gubitak vrijednosti naspram €{value}. Iznad 35% signalizira financijski stres.",
        investmentGap: "Investicijski razmak",
        investmentGapExplain: "Ukupno uloženo €{invested} minus trenutna vrijednost €{value}. Ovo pokazuje koliko ste 'izgubili' na vlasništvu do sada.",
        investmentGapDesc: "Ukupno uloženo - trenutna vrijednost",
        repairExpenses12m: "Trošak popravka za 12m",
        calculatedYearlyMileage: "Izračunata godišnja kilometraža: {km} km",
        calculatedYearlyRepairs: "Izračunati godišnji popravci: {amount}",
        set: "Postavi",
        plannedRepairCost: "Planirani trošak popravka",
        whatIfTitle: "Što ako sada potrošite {amount}?",
        updatedScore: "Ažurirani rezultat",
        updatedVerdict: "Ažurirana presuda",
        howIsItCalculated: "Kako se ovo izračunava?",
        usedLifespan: "Korišteno: {usage}% očekivanog vijeka trajanja",
        remainingLifespan: "Preostalo: ~{km} km",
        estimatedLifespan: "Procijenjeni vijek trajanja: {km} km",
        lifecycle_stage_early: "Rana faza životnog ciklusa – nizak rizik od velikih kvarova",
        lifecycle_stage_mid: "Srednja faza životnog ciklusa – normalno trošenje",
        lifecycle_stage_late: "Kasna faza životnog ciklusa – povećan rizik od popravaka",
        lifecycle_stage_end: "Kraj očekivanog vijeka trajanja – visok rizik od velikih popravaka",
        calculationExplanation: "Analiza koristi cijenu kupnje vašeg vozila, nedavne troškove popravka i procijenjenu trenutnu vrijednost za izračun financijskog zdravlja. Visoki troškovi popravka u odnosu na vrijednost auta ili brzo amortiziranje smanjit će rezultat.",
        confidenceLabel: "Povjerenje",
        confidenceLevel: {
            high: "Visoko",
            medium: "Srednje",
            low: "Nisko",
        },
        mentalFactorsTitle: "Poboljšajte točnost s vašim iskustvom",
        mentalFactorsCTA: "Brza provjera (30 sek)",
        mentalFactorsSurveyTitle: "Vaše iskustvo",
        mentalFactorsSurveyDesc: "Odgovorite na 3 brza pitanja kako biste personalizirali svoj rezultat.",
        q1: "Ispunjava li vaš automobil vaše potrebe?",
        q1Help: "Prostor, udobnost, značajke",
        q2: "Uživajte li u vožnji svog automobila?",
        q2Help: "Vizualno, udobnost, osjećaj",
        q3: "Brinete li se zbog neočekivanih kvarova?",
        q3Help: "Briga o pouzdanosti",
        q4: "Je li ovaj automobil za obitelj i duža putovanja?",
        q4Help: "Prioritet sigurnosti i pouzdanosti",
        factorsTitle: "Faktori Ocjene",
        factorsDesc: "Pogledajte što utječe na vašu ocjenu",
        newCarComparison: "Usporedba Novog Automobila",
        newCarComparisonDesc: "Usporedite svoje trenutne mjesečne troškove s kupnjom novog automobila.",
        modeLeasing: "Leasing",
        modeFullPrice: "Puna Cijena",
        downPayment: "Predujam",
        leaseYears: "Rok (Godine)",
        monthlyPayment: "Mjesečna Otplata",
        carPrice: "Puna Cijena Automobila",
        ownershipYears: "Planirano Vlasništvo (Godine)",
        insuranceMonthly: "Mjesečna CASCO / Osiguranje",
        currentMonthlyCost: "Trenutni Trošak Automobila",
        newCarMonthlyCost: "Trošak Novog Automobila",
        newCarCheaper: "Novi automobil je jeftiniji za: {amount} / mj.",
        newCarMoreExpensive: "Novi automobil je skuplji za: {amount} / mj.",
        newCarSameCost: "Troškovi su točno isti.",
        advancedSettings: "Napredne Postavke",
        yearlyMaint: "Godišnje Održavanje (€)",
        tyres3Yrs: "Gume / 3g (€)",
        depreciation5Yrs: "Amortizacija (5 g %)",
        newCarYear: "Godina Novog Automobila",
        cumulativeCosts: "Kumulativni Troškovi (Prognoza)",
        comparisonByYear: "Usporedba po Godini",
        currentCarLabel: "Trenutni Automobil",
        newCarLabel: "Novi Automobil",
        resaleValue: "Vrijednost pri preprodaji",
        startupCosts: "Troškovi pokretanja (Korišteni automobil)",
        inspection: "Inspekcija prije kupnje",
        initialMaintenance: "Početno održavanje + ulja",
        registration: "Registracija / Naknade",
        total: "Ukupno",
        currentCarTitle: "Trenutni automobil",
        newCarTitle: "Potencijalni automobil",
        upfrontInvestment: "Početna investicija",
        monthlyReality: "Stvarni mjesečni trošak",
        depreciationShort: "Amortizacija",
        howCalculated: "Kako se ovo izračunava?",
        deltaMonthly: "Mjesečna razlika",
        deltaUpfront: "Početna razlika",
        surveyMeanings: {
            practical: {
                1: "Uopće ne",
                2: "Loše odgovara",
                3: "Prosječno",
                4: "Dobro odgovara",
                5: "Savršeno odgovara",
            },
            joy: {
                1: "Frustrirajuće",
                2: "Dosadno",
                3: "Prosječno",
                4: "Ugodno",
                5: "Vrlo ugodno",
            },
            worry: {
                1: "Nisam zabrinut",
                2: "Malo zabrinut",
                3: "Zabrinut",
                4: "Vrlo zabrinut",
                5: "Sigurno ću se pokvariti u svakom trenutku",
            },
        },
        verdicts: {
            KEEP: "Financijski razuman za zadržati",
            borderline: "Na granici – pažljivo pratiti",
            sell: "Visok financijski rizik – prodaja može biti racionalna",
        },
        factors: {
            trendInc: "Rastući Trend",
            trendIncDesc: "Troškovi popravaka rastu u usporedbi s prošlom godinom.",
            lowDepreciation: "Prednost Niske Amortizacije",
            lowDepreciationDesc: "Stariji/jeftiniji automobili gube manje vrijednosti tijekom vremena.",
            stableRepairs: "Stabilni Popravci",
            stableRepairsDesc: "Vaši troškovi popravaka su stabilni ili opadaju.",
            noHistoricalData: "Nema podataka starijih od 6 mjeseci.",
            lifecycle_stage: "Faza životnog ciklusa vozila",
            high_risk_phase: "Faza visokog rizika",
            high_risk_phase_desc: "Kombinacija kasne faze životnog ciklusa i rastućih troškova popravaka ukazuje na visok rizik.",
            lowCostKm: "Učinkovit Trošak po KM",
            lowCostKmDesc: "Opća učinkovitost vožnje ovog automobila je izvrsna.",
            lowFixedCosts: "Niski Fiksni Troškovi",
            lowFixedCostsDesc: "Vaši fiksni troškovi (porezi, osiguranje) su niski.",
            usage: "Godišnja Upotreba",
            usageDesc: "Udaljenost vožena u posljednjih 12 mjeseci.",
            accidentMinor: "Manja Nesreća",
            accidentMinorDesc: "Kozmetička oštećenja ili mali popravci.",
            structuralDamage: "Strukturna Oštećenja",
            structuralDamageDesc: "Problemi s okvirom ili strukturni problemi drastično smanjuju vrijednost.",
            aiLifespanNearEnd: "Kraj Očekivanog Veka Trajanja",
            aiLifespanAging: "Starenje Komponenti",
            aiLifespanGood: "Prednost Niskih Kilometara",
            aiLifespanDesc: "Na temelju AI procijenjenog tipičnog veka trajanja za ovaj model.",
            aiUpcomingRepairs: "Nadolazeći Popravci (AI Predikcija)",
            aiUpcomingRepairsDesc: "AI predviđa velike kvarove komponenti uskoro na temelju kilometraže.",
            ownershipFatigue: "Umor od vlasništva",
            ownershipFatigueLong: "Dugotrajno vlasništvo često dovodi do mentalne spremnosti za druga vozila.",
            ownershipFatigueShort: "Početna pristranost vlasništva stvara jaču sklonost zadržavanju automobila.",
            family_priority: "Obitelj & Duža Putovanja",
            replacement_comparison: "Usporedba Zamjene",
            none: "Nema",
            surface: "Površina",
            minor: "Manje",
            moderate: "Umjereno",
            severe: "Teško",
            structural: "Strukturno",
            major: "Veliko",
            critical: "Kritično",
            full: "Puno",
            improveLabel: "Što bi poboljšalo ovo:",
            info_original_price: "Približna cijena ovog automobila kada je bio nov. Pomaže u procjeni stabilnosti vrijednosti. Stariji automobili s nižom preostalom vrijednošću su financijski sigurniji.",
            info_current_value: "Koliko biste mogli prodati danas. Koristi se za provjeru jesu li popravci veliki postotak vrijednosti automobila, što signalizira lošu investiciju.",
            info_yearly_mileage: "Veća kilometraža povećava trošenje. Niska kilometraža može značajno produžiti život automobila.",
            info_estimated_repairs: "Kontinuirani trošak održavanja automobila. Visoki godišnji troškovi smanjuju privlačnost zadržavanja automobila.",
            info_planned_repairs: "Poznati nadolazeći popravci. Simulira trenutni pritisak na vašu odluku.",
            info_ownership_years: "Koliko dugo posjedujete ovaj automobil? To utječe na psihološki umor od vlasništva i pristranost prvog kupca.",
            info_rust: "Kritični dugoročni rizik. Strukturna hrđa smanjuje sigurnost. Teška hrđa čini prodaju boljom opcijom.",
            info_crashes: "Strukturne nesreće utječu na sigurnost i pouzdanost. Također značajno smanjuju vrijednost pri preprodaji.",
            info_repaint: "Signalizira prošlu štetu ili kozmetičke popravke. Mali utjecaj osim ako nisu skrivene dublje probleme.",
            info_unresolved: "Skriveni budući troškovi. Poznate greške u elektronici, motoru ili održavanju koje zahtijevaju pažnju.",
            info_fit: "Odgovara li auto vašim potrebama (prostor, udobnost)? Loše uklapanje znači da ste vjerojatnije spremni na zamjenu.",
            info_joy: "Emocionalna vrijednost je važna. Bez radosti znači da ste mentalno spremni za novi auto.",
            info_worry: "Perceived reliability stress. Visoka briga je jak signal za zamjenu automobila.",
        },
        explanations: {
            repairFreq: "Vaš automobil je imao {visits} posjeta servisu u posljednjih 12 mjeseci. Česte posjete ukazuju na manju pouzdanost i veće neugodnosti.",
            repairVsValue: "U posljednjih 12 mjeseci, vaši popravci su koštali €{cost}, dok je procijenjena vrijednost automobila €{value}. To je {ratio}% ukupne vrijednosti automobila.",
            stableRepairsDetailYearly: "Prošle godine ste potrošili €{cost1} na popravke, ali godinu prije €{cost2}. Promjena od {percent}% ({trend}).",
            stableRepairsDetailHalfYearly: "Posljednjih 6 mjeseci ste potrošili €{cost1}, prethodnih 6 mjeseci €{cost2}. Promjena od {percent}% ({trend}).",
            mileage: "Na {mileage} km, automobil ulazi u zonu višeg rizika za velike kvarove dijelova (mjenjač, dijelovi motora).",
            planned: "Imate €{cost} u planiranim popravcima, što odmah smanjuje financijsku sigurnost zadržavanja automobila.",
            lowDep: "Automobili procijenjeni oko €{value} gube vrlo malo vrijednosti godišnje, što kompenzira veće troškove popravaka.",
            depRisk: "Vaš automobil ima {age} godina i većinom je završio svoj ciklus amortizacije, što znači da ne gubite novac na pad njegove vrijednosti.",
            stable: "Potrošili ste €{costThisYear} ove godine naspram €{costLastYear} prošle godine, što je smanjenje od {percent}%. Predvidivi troškovi su matematički povoljni.",
            costKm: "Proveli ste {km} km prošle godine. Troškovi vožnje bili su €{costKm} po kilometru, što pokazuje izvrsnu ekonomsku učinkovitost.",
            fixedCosts: "Platili ste €{costs} u fiksnim godišnjim troškovima (osiguranje/porez). Ova niska stopa daje dodatni mir.",
            usage: "Vožnja je oko {km} km godišnje na temelju vaših evidencija.",
            practical_fit: "Ocijenili ste praktičnu prilagodbu na {score}/5, prilagođujući matematičku ocjenu za {impact} bodova.",
            emotional_satisfaction: "Ocijenili ste svoje emocionalno zadovoljstvo na {score}/5, prilagođujući ocjenu za {impact} bodova.",
            reliability_anxiety: "Vaša sigurnost u pouzdanost je {score}/5, utječući na ocjenu za {impact} bodova.",
            rust: "Teška strukturna ili donja hrđa obično znači opasnosti za sigurnost ili scenarije otpisivanja.",
            accident: "Prethodna oštećenja, ovisno o težini, inherentno smanjuju vrijednost i sigurnost vozila.",
            structural: "Strukturni problemi automatski čine automobil financijski opasnim.",
            ai_lifespan: "Na {current} km, automobil je završio {ratio}% svog AI procijenjenog životnog vijeka ({expect} km).",
            ai_repairs: "AI podaci ukazuju na to da se obično dogodi {count} tipičnih velikih popravaka specifičnih za model na ovoj kilometraži.",
            lifecycle_stage: "Što znači životni vijek? {total} km – ovo je AI-predviđena točka kada obično počinju veliki strukturni popravci (motor, mjenjač itd.) za ovaj model. To nije kraj života automobila – automobil se još uvijek može voziti, ali s znatno višim troškovima održavanja. Tipični puni fizički životni vijek automobila je 500k–1M km, ali postaje ekonomski neisplativ mnogo ranije.",
        },
        ratios: {
            healthy: "Zdrav",
            monitor: "Pratiti",
            highRisk: "Visok rizik",
            stable: "Stabilno",
            warning: "Upozorenje",
            financialStress: "Financijski stres",
        },
        proFeatureTitle: "Pro značajka: Način popravka",
        proFeatureDesc: "Otključajte motor odluka kako biste dobili profesionalnu financijsku analizu popravaka vašeg vozila. Besplatni korisnici vide demonstraciju s uzorkom podataka.",
        viewDemo: "Pogledajte uživo demonstraciju",
        upgradeToUnlock: "Nadogradite na PRO za analizu vašeg automobila",
    },
    carTasks: {
        title: "Zadaci automobila",
        placeholderTitle: "Praćenje održavanja",
        placeholderDesc: "Raspored održavanja za vaš model automobila.",
        demoTitle: "Zadaci održavanja automobila",
        demoSubtitle: "Pametno praćenje za vaše vozilo",
        feature1Title: "Automatizirana generacija zadataka",
        feature1Desc: "Automatski generira zadatke poput promjena ulja, zamjena filtera i provjera remena na temelju modela vašeg automobila.",
        feature2Title: "Integracija troškova",
        feature2Desc: "Analizira vašu povijest usluga kako bi razumio što je već učinjeno i kada.",
        feature3Title: "Pametni podsjetnici",
        feature3Desc: "Primajte obavijesti na temelju vremena i kilometraže. Praćenje se automatski resetira kada označite zadatak kao dovršen.",
        getStarted: "Započni",
        fakeDoorPopupTitle: "Povratne informacije dobrodošle",
        fakeDoorPopupMessage: "Trenutno razvijamo zadatke održavanja automobila. Ova značajka će vam omogućiti automatsko praćenje intervala usluga. Koje specifične zadatke ili značajke biste najviše željeli vidjeti?",
        fakeDoorPopupPlaceholder: "Vaše misli...",
        noTasksYet: "Još nema zadataka",
        deleteAllTitle: "Izbriši popis zadataka?",
        deleteAllMessage: "Jeste li sigurni da želite izbrisati svih {count} zadataka za ovaj automobil? Ova radnja se ne može poništiti.",
        deleteAllSuccess: "Svi zadaci su uspješno izbrisani.",
        sortPriority: "Prioritet",
        sortType: "Vrsta",
        sortDate: "Najnovije",
        status: {
            overdue: "ZAKAŠNJENO",
            pending: "NA ČEKANJU",
            noData: "NEMA PODATAKA",
            upcoming: "Nadolazeće",
            nextIn: "Sljedeće za {dist} {unit}",
            overdueBy: "{dist} {unit} zakašnjelo",
            afterDays: "Za {days} dana",
            overdueDays: "{days} dana zakašnjelo",
        },
        form: {
            newTitle: "Novi zadatak",
            actionType: "Inspekcija ili zamjena?",
            intervalMonths: "Interval (Mjeseci)",
            intervalDistance: "Interval (Udaljenost)",
            diffFirstInterval: "Prvi interval se razlikuje od osnovnog intervala",
            firstInterval: "Prvi interval",
            historyToggle: "Je li ovaj zadatak ikada obavljen za ovaj automobil?",
            historyToggleDesc: "Ako NE, pretpostavljamo da nikada nije bio obavljen od proizvodnje.",
            lastPerformedOptional: "Kada je posljednji put obavljen? (Opcionalno)",
            deleteTitle: "Izbriši zadatak",
            deleteConfirm: "Jeste li sigurni da želite izbrisati ovaj zadatak?",
            saveError: "Nije uspjelo spremanje zadatka",
            historyConfirmed: "Povijest potvrđena",
            reminders: "Podsjetnici",
            notifyMileage: "Obavijesti me kada se dostigne procijenjena kilometraža",
            notifyDate: "Obavijesti me kada dođe datum",
            nextMileageReminder: "Procijenjeni datum",
            nextDateReminder: "Datum dospijeća",
            estimatedDate: "Procijenjeni datum",
            missingLastMileage: "Nedostaje posljednji odrađeni kilometraža",
            missingLastDate: "Nedostaje posljednji odrađeni datum",
            missingStartDate: "Nije moguće odrediti datum početka",
            additionalOptions: "Dodatne opcije",
            reminderInfoMissing: "Informativno stanje: podsjetnici su onemogućeni dok se ne dostave posljednji podaci.",
        },
    },
    dashboard: {
        title: "Nadzorna ploča",
        quickActions: "Brze radnje",
        addExpense: "Dodaj trošak",
        editCar: "Uredi automobil",
        recentExpenses: "Troškovi",
        seeAll: "Pogledajte sve",
        recentGallery: "Datoteke",
        thisMonth: "Ovaj mjesec",
        totalSpent: "Ukupno potrošeno",
        avgPerMonth: "Prosjek/mjesec",
        recentNotes: "Bilješke",
        recentParts: "Dijelovi",
        noRecentExpenses: "Nema nedavnih troškova",
        noRecentGallery: "Nema nedavnih fotografija",
        noRecentNotes: "Nema nedavnih bilješki",
        noRecentParts: "Nema nedavnih dijelova",
        createNote: "Kreiraj novu",
        createPart: "Kreiraj novi",
        createExpense: "Kreiraj novi",
        noFiles: "Još nisu dodane datoteke",
        needSomethingMore: "Trebate nešto više?",
        letUsKnow: "javite nam!",
    },
    expenseTypes: {
        editTitle: "Uredi vrstu troška",
        newTitle: "Nova vrsta troška",
        categoryName: "Naziv kategorije",
        placeholderName: "npr. Servis",
        signatureColor: "Boja potpisa",
        icon: "Ikona kategorije",
        deleteConfirm: "Jeste li sigurni da želite izbrisati vrstu '{name}'?",
    },
    spareParts: {
        title: "Rezervni dijelovi",
        connectedWithRecords: "Povezano s evidencijama",
        toBuy: "Za kupiti",
        usedInExpenses: "Korišteni u troškovima",
        noPartsToBuy: "Nema dijelova dodanih na popis za kupnju",
        noPartsUsed: "Nema dijelova povezanih s troškovima još",
        quantity: "Količina",
        partCode: "Kod dijela",
        price: "Cijena",
        link: "Veza",
        comment: "Komentar",
        addPart: "Dodaj rezervni dio",
        editPart: "Uredi rezervni dio",
        openPart: "Otvorite unos dijela",
        nameLabel: "Naziv",
        manufacturerLabel: "Proizvođač",
        priceLabel: "Cijena ({currency})",
        imagesLabel: "Datoteke",
        linkedHistory: "Povezana povijest",
        partManagedNote: "Ovaj dio se upravlja kroz trošak",
        cannotDeleteNote: "Budući da je ovaj dio povezan s troškom, ne može se izbrisati odvojeno. Izbrišite ili uredite trošak kako biste upravljali životnim ciklusom ovog dijela.",
        partNamePlaceholder: "Naziv dijela...",
        manufacturerPlaceholder: "Bosch, Brembo, itd.",
        additionalInfoPlaceholder: "Dodatne informacije...",
        namePlaceholder: "npr. Kočione pločice",
        codePlaceholder: "npr. 5Q0 698 151",
        linkPlaceholder: "https://...",
        vinPlaceholder: "WBADT...",
        savePart: "Spremi dio",
        deletePart: "Izbriši rezervni dio",
        deleteConfirm: "Jeste li sigurni da želite izbrisati ovaj rezervni dio?",
        sparePartsLabel: "Rezervni dijelovi",
        partNumber: "Dio #{number}",
        imagesLimitLabel: "Datoteke (do 5)",
        optional: "(opcionalno)",
        selectPart: "Odaberite rezervni dio",
        createNew: "Kreirajte novi rezervni dio",
        searchPlaceholder: "Pretraži po nazivu ili kodu...",
        noResults: "Nema pronađenih dijelova",
        noPartsYet: "Još nema dijelova. Kreirajte svoj prvi!",
        selectorDescription: "Pronađite i odaberite postojeći rezervni dio ili kreirajte novi",
        alreadyAdded: "Ovaj dio je već dodan",
        statistics: {
            avgPrice: "Prosjek",
            lastPrice: "Zadnja",
            usedTimes: "Korišteno {count} puta",
            totalPurchased: "Ukupno: {quantity}x",
        },
        usage: {
            title: "Ova kupnja",
            quantity: "Količina",
            pricePerUnit: "Cijena po jedinici",
            comment: "Komentar",
            commentPlaceholder: "npr., Kupljeno u AutoZoni",
            total: "Ukupno",
            transactionData: "Ova transakcija",
        },
        masterData: "Glavne informacije o dijelu",
        masterRecord: {
            title: "Detalji dijela (zajednički)",
            editMaster: "Uredi glavni zapis",
            warning: "Promjene u glavnom zapisu utječu na sve upotrebe",
        },
    },
    reminders: {
        title: "Podsjetnici",
        reminder: "Podsjetnik",
        noteReminder: "Podsjetnik za bilješku",
        partReminder: "Podsjetnik za dio",
        today: "Danas",
        tomorrow: "Sutra",
        yesterday: "Jučer",
        inXDays: "za {x} dana",
        xDaysAgo: "prije {x} dana",
        inXMonths: "za {x} mjeseci",
        xMonthsAgo: "prije {x} mjeseci",
        active: "Aktivan",
        activeDesc: "Ako je potrebno, možete isključiti ovaj podsjetnik bez brisanja",
        disabled: "Onemogućen",
        yearly: "Godišnje",
        markSeen: "Potvrdi",
        addReminder: "Novi podsjetnik",
        editReminder: "Uredi podsjetnik",
        extraReminders: "Dodatni podsjetnici",
        extraRemindersDesc: "Pošaljite još 3 podsjetnika sljedećih dana (ukupno 4) ako ne budu zaustavljeni.",
        remindDate: "Datum",
        remindTime: "Vrijeme",
        repeatYearly: "Ponovi godišnje",
        repeatYearlyDesc: "Ovaj podsjetnik će se automatski ponavljati svake godine na isti datum/mjesec/dan/vrijeme dok ne bude onemogućen",
        standalone: "Samostalni podsjetnici",
        embedded: "Povezani podsjetnici",
        noReminders: "Nema aktivnih podsjetnika",
        deleteReminder: "Izbriši podsjetnik",
        nameLabel: "Ime",
        descriptionLabel: "Opis",
        namePlaceholder: "Ime podsjetnika",
        descriptionPlaceholder: "Kratak opis ili bilješka",
        simulateReminder: "Simuliraj trenutak podsjetnika",
        simulateSuccess: "E-mail za simulaciju poslan",
        timezone: "Vremenska zona",
        nextReminder: "Sljedeći podsjetnik",
        futureTimeError: "Vrijeme podsjetnika mora biti u budućnosti",
    },
    notes: {
        title: "Bilješke",
        emptyNote: "Prazna bilješka",
        noNotes: "Još nema bilješki",
        addNote: "Dodaj bilješku",
        editNote: "Uredi bilješku",
        viewNote: "Pogledaj bilješku",
        openNote: "Otvorite unos bilješke",
        titleLabel: "Naslov",
        contentLabel: "Sadržaj",
        noteTitlePlaceholder: "Naslov bilješke...",
        noteContentPlaceholder: "Napišite svoju bilješku ovdje...",
        saveNote: "Spremi bilješku",
        deleteNote: "Izbriši bilješku",
        publicNote: "Učini bilješku javnom",
        publicNoteDesc: "Drugi mogu vidjeti ovu bilješku putem dijeljenog linka",
        deleteConfirm: "Jeste li sigurni da želite izbrisati ovu bilješku?",
        enterTitleAlert: "Molimo unesite naslov",
        saveFailed: "Nije uspjelo spremanje bilješke",
        thisNote: "Ova bilješka",
        deleteFailed: "Nije uspjelo brisanje bilješke",
        pinToTop: "Zakači na vrh",
    },
    locations: {
        title: "Lokacije",
        singleTitle: "Lokacija",
        newLocation: "Nova lokacija",
        emptyLocation: "Prazna lokacija",
        noLocations: "Za statistiku - možete dodati lokaciju gdje je došlo do ovog troška automobila",
        addLocation: "Dodaj lokaciju",
        editLocation: "Uredi lokaciju",
        viewLocation: "Pogledaj lokaciju",
        openLocation: "Otvori lokaciju",
        createNew: "Kreiraj novu lokaciju",
        selectLocation: "Odaberi lokaciju",
        searchLocations: "Pretraži lokacije...",
        nameLabel: "Ime",
        addressLabel: "Adresa ili Koordinate",
        descriptionLabel: "Komentar/Opis",
        namePlaceholder: "npr., Servis u centru",
        mapLabel: "Lokacija",
        searchPlaceholder: "Pretraži adresu...",
        addressPlaceholder: "Unesite adresu i odaberite...",
        descriptionPlaceholder: "Dodatne informacije...",
        fillAddress: "Ispuni adresu s mape",
        saveLocation: "Spremi lokaciju",
        deleteLocation: "Izbriši lokaciju",
        deleteConfirm: "Jeste li sigurni da želite izbrisati ovu lokaciju?",
        enterNameAlert: "Molimo unesite ime",
        saveFailed: "Nije uspjelo spremanje lokacije",
        thisLocation: "Ova lokacija",
        deleteFailed: "Nije uspjelo brisanje lokacije",
        myLocations: "Moje lokacije",
        usedInEntries: "Korišteno u unosima",
        noEntries: "Lokacija nije korištena",
        noEntriesThisCar: "Ova lokacija nije korištena za ovaj automobil",
        removeLocation: "Ukloni lokaciju",
        noResults: "Nema pronađenih rezultata",
    },
    gallery: {
        title: "Datoteke",
        noImages: "Nema dodanih slika",
        addImagesNote: "Dodajte slike automobila ili troškova",
        totalImages: "Ukupno {count} slika",
        imageAlt: "Slika {number}",
        commentPlaceholder: "Komentar datoteke",
        isReceipt: "Ova datoteka je račun",
        deleteImageTitle: "Izbriši datoteku",
        deleteImageConfirm: "Jeste li sigurni da želite trajno izbrisati ovu datoteku?",
    },
    search: {
        placeholder: "Pretraži troškove, dijelove, bilješke...",
        typeToSearch: "Upišite za početak pretraživanja",
        noResults: "Nema pronađenih rezultata za '{query}'",
        carImage: "Slika automobila",
        expenseImage: "Slika troška",
        noteImage: "Slika bilješke",
        galleryImage: "Slika galerije",
        untitledExpense: "Neimenovani trošak",
    },
    landing: {
        nav: {
            features: "Značajke",
            howItWorks: "Kako radi",
            pricing: "Cijene",
            login: "Prijava",
            getStarted: "Početak",
            garage: "Garaža",
        },
        hero: {
            title: "Znajte točno što vaš automobil",
            subtitle: "Stvarno košta",
            description: "Pratite troškove, evidentirajte popravke i vidite gdje vaš novac stvarno ide.",
            subheadline: "Profesionalna nadzorna ploča vođena podacima za pomne vlasnike automobila.",
            startTracking: "Početak",
            viewDemo: "Demo Automobil ->",
            trustSignal: "Pridružite se 1,200+ pomnih vlasnika koji su već zabilježili više od 5 milijuna kilometara stvarnih troškova automobila.",
            ctaNote: "Bez kreditne kartice. Bez napornih prodavača. Samo jasnoća.",
            benefits: {
                repairVsSell: {
                    title: `Popravak vs. Prodaja`,
                    description: `Prepoznajte prag "Popravak vs. Prodaja" — Prestani se pitati ulažeš li novac u bunar bez dna. Znajte točan trenutak kada popravak više nije pametna investicija.`
                },
                costPerKm: {
                    title: `Trošak po KM`,
                    description: `Pratite svoj stvarni trošak po kilometru — Izađite iz nadzorne ploče. Vidite cjelokupnu financijsku sliku vaših vozačkih navika koje druge aplikacije izostavljaju.`
                },
                automation: {
                    title: `Automatizacija`,
                    description: `Automatizirajte svoje vođenje evidencije — Samo proslijedite svoje račune ili jednostavno pošaljite svoje bilješke putem e-pošte. Naša AI organizira tehničku povijest vašeg automobila za vas.`
                }
            },
        },
        features: {
            title: "Sve što trebate za upravljanje svojim automobilom",
            subtitle: "Prestanite koristiti proračunske tablice i neuredne mape. Moji troškovi automobila donose profesionalne alate za upravljanje flotom u vašu osobnu garažu.",
            expenseTracking: {
                title: "Praćenje troškova",
                description: "Zabilježite gorivo, servis, osiguranje i popravke. Kategorizirajte troškove i vizualizirajte trendove potrošnje tijekom vremena.",
            },
            spareParts: {
                title: "Upravitelj rezervnih dijelova",
                description: "Držite detaljnu evidenciju rezervnih dijelova, brojeva dijelova i bilješki o kompatibilnosti za sve vaše popravke.",
            },
            serviceHistory: {
                title: "Povijest servisa i bilješke",
                description: "Održavajte digitalnu servisnu knjigu. Dodajte detaljne bilješke o održavanju, modifikacijama ili budućim planovima.",
            },
            documentStorage: {
                title: "Skladištenje dokumenata",
                description: "Prenesite račune, fakture i fotografije svog automobila. Držite svu svoju dokumentaciju sigurnom i dostupnom.",
            },
            emailForwarding: {
                title: "Prosljeđivanje e-pošte",
                description: "Proslijedite fakture izravno u svoju jedinstvenu pristiglu poštu. Izvuc ćemo podatke i automatski ih dodati na vašu nadzornu ploču.",
            },
            multiCar: {
                title: "Garaža za više automobila",
                description: "Upravljajte jednim automobilom ili cijelom flotom. Prebacujte se između vozila odmah i vidite agregirane statistike.",
            },
            repeatingExpenses: {
                title: "Ponovljeni troškovi",
                description: "Automatizirajte praćenje redovitih mjesečnih troškova poput osiguranja, parkiranja ili leasinga.",
            },
            smartReminders: {
                title: "Pametni podsjetnici",
                description: "Postavite prilagođene alarme za rezervne dijelove i bilješke o uslugama kako ne biste propustili zadatak održavanja.",
            },
        },
        howItWorks: {
            title: "Jednostavan, moćan radni proces",
            step1: {
                title: "Dodajte svoje vozilo",
                description: "Unesite podatke o svom automobilu kako biste stvorili svoju digitalnu garažu.",
            },
            step2: {
                title: "Zabilježite troškove i datoteke",
                description: "Fotografirajte račun ili proslijedite e-poštu. Mi ćemo se pobrinuti za ostalo.",
            },
            step3: {
                title: "Dobijte uvide",
                description: "Pogledajte svoje troškove po kilometru, mjesečne troškove i vremensku liniju održavanja.",
            },
        },
        useCases: {
            title: "Savršeno za",
            enthusiasts: {
                title: "Entuzijaste automobila",
                description: "Pratite svaku modifikaciju, broj dijela i interval održavanja za svoj projektni automobil.",
            },
            dailyDrivers: {
                title: "Svodnevne vozače",
                description: "Znajte točno koliko košta vaše putovanje i nikada ne propustite datum servisa.",
            },
            flippers: {
                title: "Pametan preprodavač",
                description: "Izgradite provjerljivu količinu podataka koja dokazuje pravu vrijednost vašeg automobila kupcima.",
            },
            fleets: {
                title: "Male flote",
                description: "Upravljajte više poslovnih vozila na jednom mjestu bez bloat-a softvera za poduzeća.",
            },
        },
        foundersNote: {
            title: "Osnivačeva napomena",
            content: "Gradim MyCarCosts da bude ultimativni alat za ljude koji zapravo brinu o svojim automobilima. Nedostaje li neka funkcija u vašem radnom toku? Kontaktirajte me izravno. Ako ima smisla za zajednicu, izgradit ćemo to zajedno.",
        },
        pricing: {
            freeLimitedTime: "Besplatno na ograničeno vrijeme",
            title: "Jednostavne, transparentne cijene",
            subtitle: "Započnite besplatno, nadogradite kako rastete.",
            perMonth: "mjesečno",
            monthly: "Mjesečno",
            yearly: "Godišnje",
            save25: "Uštedite 25%",
            billedAnnually: "Naplaćuje se godišnje ({amount})",
            free: {
                title: "Besplatno",
                cta: "Započnite",
            },
            pro: {
                title: "Pro",
                cta: "Nadogradite na Pro",
                recommended: "Preporučeno",
                earlyAdopter: "Cijena za rane korisnike",
                priceLock: "Osigurajte ovu cijenu sada. Cijena može porasti u budućnosti.",
            },
            custom: {
                title: "Custom",
                cta: "Kontaktirajte nas",
            },
            features: {
                oneCar: "1 automobil",
                unlimitedExpenses: "Neograničeni troškovi",
                unlimitedSpareParts: "Neograničeni rezervni dijelovi",
                unlimitedNotes: "Neograničene bilješke",
                repeatedExpenses: "Ponovljeni troškovi",
                emailReminders: "Bilješke i podsjetnici za rezervne dijelove putem e-pošte",
                basicStatistics: "Osnovna statistika",
                fullStatistics: "Potpuna statistika",
                storage50mb: "50 Mb pohrane datoteka",
                unlimitedArchivedCars: "Neograničena arhivirana vozila",
                dataExport: "Izvoz podataka",
                allInFreePlus: "sve u besplatnom plus:",
                threeCars: "Do 3 automobila",
                storage2gb: "2 Gb pohrane datoteka",
                emailParsing: "Obrada e-pošte",
                carAdmins: "Administratori automobila",
                moreCars: "Više automobila",
                moreFileStorage: "Više pohrane datoteka",
                customRequirements: "Prilagođeni zahtjevi",
            },
            upgradePopup: {
                title: "Uskoro!",
                message: "Pro i prilagođene verzije još nisu pokrenute, ali će uskoro biti. Da nam pomognete da brže pokrenemo - molimo vas da zapišete koju specifičnu funkciju očekujete od pro / prilagođene verzije, ili bilo što drugo što biste željeli da poboljšamo kako bismo ovu platformu učinili još boljom za vas!",
                placeholder: "Ovdje napišite svoje povratne informacije...",
                submit: "Pošalji",
                cancel: "Otkaži",
                thanksTitle: "Hvala vam!",
                thanksMessage: "Primili smo vaše povratne informacije i radit ćemo na tome da MyCarCosts učinimo još boljim!",
                thanksOk: "U redu",
            },
        },
        migration: {
            title: "Prelazite s Excela ili druge aplikacije?",
            subtitle: "Nudimo profesionalnu uslugu migracije podataka kako bismo vas odmah pokrenuli.",
            pricingModel: "Model cijena",
            small: {
                title: "Mali skup podataka",
                description: "< 500 redaka",
                price: "$19–29",
            },
            medium: {
                title: "Srednji skup podataka",
                description: "500–5,000 redaka",
                price: "$49",
            },
            large: {
                title: "Veliki / Neuredni",
                description: "Naslijeđeni sustavi ili složene datoteke",
                price: "Prilagođena ponuda",
            },
            process: {
                title: "Kako to funkcionira",
                step1: "Podnosite svoju datoteku",
                step2: "Procjenjujemo podatke",
                step3: "Jednokratna uplata",
                step4: "Mi upravljamo uvozom",
            },
            cta: "Zatražite migraciju",
        },
        repairAnalysisSection: {
            title: "Popraviti ili prodati? Neka podaci odluče.",
            subtitle: "Profesionalna financijska analiza za vaše vozilo. Prestanite nagađati i počnite znati jesu li ti popravci doista vrijedni.",
            features: {
                personalized: {
                    title: "Personalizirana analiza",
                    description: "Za vaše praćene automobile koristimo stvarne povijesne troškove i parametre, dodajući planirane troškove za generiranje procjene.",
                },
                public: {
                    title: "Javni simulator",
                    description: "Procjenjujete potencijalnu kupnju? Iskoristite naš javni alat na /repair za generiranje detaljne analize unosom samo nekoliko ključnih podataka.",
                },
                whatIf: {
                    title: "Što-ako simulator",
                    description: "Unesite planirani trošak popravka i odmah vidite kako to utječe na financijski rezultat vašeg automobila.",
                },
            },
            cta: "Pogledajte uzorak analize",
        },
        faq: {
            title: "Često postavljana pitanja",
            subtitle: "Sve što trebate znati o My Car Costs",
            questions: {
                mobileApps: {
                    question: "Hoće li biti iOS i Android aplikacije?",
                    answer: "Da! Mobilne aplikacije za iOS i Android uskoro dolaze. Radimo naporno kako bismo vam pružili najbolje mobilno iskustvo.",
                },
                dataPrivacy: {
                    question: "Je li moji podaci privatni i sigurni?",
                    answer: "Apsolutno. Vaši podaci su šifrirani i pohranjeni sigurno. Samo vi možete pristupiti informacijama o vašem automobilu osim ako izričito ne odlučite učiniti ih javnima.",
                },
                freePlan: {
                    question: "Je li besplatni plan doista besplatan zauvijek?",
                    answer: "Da! Besplatni plan će uvijek biti dostupan za jedan automobil i sve osnovne značajke. Možete nadograditi na Pro u bilo kojem trenutku za do 3 automobila i napredne značajke.",
                },
                dataExport: {
                    question: "Mogu li izvesti svoje podatke?",
                    answer: "Da, možete izvesti sve svoje podatke u bilo kojem trenutku u CSV ili PDF formatu. Vaši podaci su vaši, i nikada niste zaključani.",
                },
                emailImport: {
                    question: "Kako funkcionira uvoz e-pošte?",
                    answer: "Svaki automobil dobiva jedinstvenu adresu e-pošte. Samo proslijedite svoje račune i automatski ćemo izdvojiti podatke.",
                },
                multipleUsers: {
                    question: "Mogu li više osoba pristupiti istom automobilu?",
                    answer: "Trenutno, svaki automobil pripada jednom računu. Međutim, možete učiniti automobil javno vidljivim kako biste podijelili pristup samo za čitanje s drugima.",
                },
            },
        },
        cta: {
            title: "Prestanite nagađati. Počnite znati.",
            subtitle: "Pretvorite povijest svog automobila u jasne financijske odluke. Pridružite se tisućama pametnih vlasnika koji točno znaju kada investirati ili prodati.",
            button: "Započni sada",
            note: "Bez kreditne kartice. Bez napornih prodavača. Samo jasnoća.",
        },
        footer: {
            product: "Proizvod",
            legal: "Pravno",
            changelog: "Povijest promjena",
            privacy: "Politika privatnosti",
            contact: "Kontakt",
            contactEmail: "info@mycarcosts.com",
            questions: "Imate pitanja? Kontaktirajte nas na:",
        },
        privacy: {
            title: "Politika privatnosti",
            lastUpdated: "Zadnje ažurirano: 25. ožujka 2026.",
            introduction: "U My Car Costs ozbiljno shvaćamo vašu privatnost. Ova politika objašnjava kako postupamo s vašim podacima.",
            dataCollection: {
                title: "Prikupljanje podataka",
                description: "Prikupljamo samo apsolutni minimum informacija potrebnih za pružanje naše usluge.",
                email: "Identitet računa: Koristimo vašu e-mail adresu kao vaš jedinstveni identifikator i za autentifikaciju (npr. magic linkovi ili Google prijava).",
                documents: "Pohrana dokumenata: Datoteke koje prenesete pohranjuju se sigurno u šifriranoj cloud pohrani.",
            },
            carData: {
                title: "Kontrola vaših podataka",
                description: "Informacije koje unesete (troškovi, kilometraža, dijelovi) pohranjuju se za vašu osobnu upotrebu i analizu.",
                noValidation: "Ne validiramo podatke o automobilu koje pružate; vaša je odgovornost osigurati točnost.",
                privateByDefault: "Prema zadanim postavkama, vaši podaci su privatni. Tehnički identifikatori za datoteke nisu sekvencijalni i nisu indeksirani od strane tražilica.",
                rightToForgotten: "Pravo na zaborav: Možete izbrisati svoj račun u bilo kojem trenutku, što odmah i trajno uklanja sve vaše zapise i datoteke.",
            },
            thirdParty: {
                title: "Usluge trećih strana",
                description: "Ne prodajemo vaše osobne podatke. Prilikom korištenja Google prijave, pristupamo samo vašoj e-mail adresi u svrhu identifikacije.",
            },
            emailIngestion: {
                title: "Obrada e-pošte",
                description: "E-pošta poslana našoj usluzi pohranjuje se kako bismo osigurali povijest obrade. Pojedinačne e-poruke ili cijelu povijest možete ručno izbrisati u bilo kojem trenutku.",
            },
        },
        emails: {
            deleteAll: "Izbriši sve",
            deleteAllConfirm: "Jeste li sigurni da želite izbrisati cijelu povijest e-pošte za ovaj automobil? Ova radnja je nepovratna.",
            deleteConfirm: "Jeste li sigurni da želite izbrisati ovu e-poruku?",
            noEmails: "Još nema primljenih e-poruka.",
        },
        terms: {
            title: "Uvjeti i odredbe",
            lastUpdated: "Zadnje ažurirano: 25. ožujka 2026.",
            introduction: "Pristupanjem ili korištenjem MyCarCosts-a, slažete se da ćete biti vezani ovim Uvjetima i odredbama. Ako se ne slažete, nemojte koristiti našu uslugu.",
            acceptance: {
                title: "1. Prihvaćanje uvjeta",
                description: "Ovi uvjeti predstavljaju pravno obvezujući ugovor između vas i MyCarCosts-a u vezi s vašim korištenjem naše aplikacije i usluga.",
            },
            service: {
                title: "2. Opis usluge",
                description: "MyCarCosts pruža platformu za praćenje troškova vozila, upravljanje održavanjem i financijsku analizu. To uključuje analizu računa potpomognutu umjetnom inteligencijom i alate za vizualizaciju podataka.",
            },
            responsibilities: {
                title: "3. Odgovornosti korisnika",
                description: "Odgovorni ste za točnost svih podataka koje unesete, uključujući kilometražu, VIN brojeve i troškove. Morate čuvati svoje vjerodostojne podatke za prijavu (e-mail/magic link) sigurnima i ne dijeliti ih s neovlaštenim stranama.",
            },
            plans: {
                title: "4. Planovi usluga i ograničenja",
                description: "Nudimo besplatne i Pro planove s različitim ograničenjima pohrane, broja automobila i učitavanja. Zadržavamo pravo izmjene ovih ograničenja ili uvođenja novih razina pretplate u bilo kojem trenutku.",
            },
            disclaimer: {
                title: "5. Odricanje od odgovornosti i točnost",
                description: "MyCarCosts je informativni i organizacijski alat. Ne pružamo službene potvrde o stanju vozila. Podatke s računa koje je analizirala umjetna inteligencija korisnik bi uvijek trebao provjeriti radi točnosti.",
            },
            liability: {
                title: "6. Ograničenje odgovornosti",
                description: "MyCarCosts se pruža u obliku 'kakav jest'. Nismo odgovorni za bilo kakve mehaničke probleme, financijske gubitke ili netočnosti podataka nastale korištenjem naše aplikacije.",
            },
            termination: {
                title: "7. Raskid",
                description: "Korištenje usluge možete prekinuti i izbrisati svoje podatke u bilo kojem trenutku. Zadržavamo pravo suspendirati ili zatvoriti račune koji krše ove uvjete ili pokazuju zloupotrebu.",
            },
        },
    },
            audit: {
        hero: {
            badge: 'New: Protection Tool',
            title: 'Consult the Oracle.',
            subtitle: 'Stop second-guessing your mechanic. Paste your quote, describe the noise, or upload a photo. Get a direct, logic-based verdict in 60 seconds.',
            cta: 'Consult the Oracle',
            smallPrint: '100% Private. No credit card required.',
            walletSecurity: 'AI-Powered Security for Your Wallet'
        },
        demo: {
            title: 'Audit Results',
            verdictSell: 'Verdict: SELL',
            repairVsValue: 'Repair vs Value',
            cashGapSavings: 'Cash Gap to Replace',
            savingsValue: '$3,200 Savings',
            roiStrategyTitle: 'ROI Strategy',
            roiStrategyText: 'Investing $2,100 into a deteriorating $4,500 asset is a negative ROI. Replacing with a 2018 model now saves you $3,200 in long-term equity.',
            benefitsTitle: 'Stop Guessing. Master Your Car\'s ROI.',
            ctaSubtext: 'Stop guessing. Put your car\'s costs into logic-driven perspective.'
        },
        form: {
            uploadTitle: 'Photos or Documents (Optional)',
            uploadDesc: 'Upload a photo of your quote or just a picture of the problem area.',
            emailLabel: 'Email Address',
            emailPlaceholder: 'Where to send your report?',
            carLabel: 'Car Model',
            carPlaceholder: 'e.g. 2018 BMW X5 TDI 2.0 sedan',
            descLabel: 'Describe the problem',
            descPlaceholder: 'Paste your mechanic quote, describe the noise, or tell us the problem...',
            submit: 'Consult the Oracle',
            submitting: 'Processing...',
            successTitle: 'Quote Received!',
            successDesc: 'Our AI agents are analyzing your data. You will receive a detailed report at {email} within 60 seconds.',
            errorNoFiles: 'Please provide a description or upload a file.',
            errorNoEmail: 'Please enter your email address.',
            verifiedBy: 'Verified by Double-Agent Protocol'
        },
        progress: {
            analyzing: 'Analysis in progress...',
            scanning: 'Scanning Documents',
            checking: 'Checking Market Data',
            roi: 'ROI Calculations',
            finalizing: 'Finalizing Report',
            lightningTitle: 'First Look Verdict',
            lightningBadge: 'LIGHTNING ANALYSIS',
            firstImpression: 'First Impression',
            checkEmail: 'Check your email in 60 seconds',
            anotherAudit: 'Audit Another Situation',
            statusDesc: 'Our Double-Agent system is scrutinizing your data. The final report will be sent to your email.'
        },
        valueProps: {
            negotiation: {
                title: 'ROI Analysis',
                desc: 'Stop overpaying for labor. Get data-backed arguments for real repair times.'
            },
            peace: {
                title: 'Verdict in 60s',
                desc: 'Know for sure if your mechanic is honest about repairs or trying to "bloat" the bill.'
            },
            scams: {
                title: 'Avoid Common Scams',
                desc: 'Our database found that the average quote in big city dealerships is padded by 22% for "consultation" fees that aren\'t necessary.'
            },
            technical: {
                title: 'Replacement Logic',
                desc: 'We calculate the "Cash Gap" — the true cost of fixing your car versus replacing it with something reliable.'
            }
        },
        cta: {
            title: 'Stop dumping cash into a car that isn’t worth it.',
            button: 'Audit the Situation Now'
        },
        howItWorks: {
            title: 'How It Works',
            subtitle: 'The "Double-Agent" verification system ensures you get facts, not fluff.',
            extract: {
                title: 'Data Intake',
                desc: 'We analyze your situation and car model, factoring in mileage and historical maintenance trends.'
            },
            analyze: {
                title: 'Market Analysis',
                desc: 'Our AI compares repair costs against current market valuations and model reliability scores.'
            },
            audit: {
                title: 'ROI Calculation',
                desc: 'We calculate the financial gap between fixing your current vehicle and moving to a better one.'
            },
            verdict: {
                title: 'The Verdict',
                desc: 'You receive a clear "Repair or Sell" report with logic-driven strategy and priority action items.'
            }
        },
        results: {
            priceRealityCheck: 'Price Reality Check',
            roadmapTitle: 'What breaks next?',
            roadmapBadge: 'Roadmap Teaser',
            unlockFullReport: 'Unlock Full Forensic Audit',
            realWorldInsights: 'Real-World Insights',
            oracleAdvice: 'Real Advice from the Oracle',
            oracleAdviceSub: 'See how our AI helps real people navigate complex car problems every day.',
            readFullAudit: 'Read Full Audit',
            potentialSaving: 'Potential Saving',
            getYourOwn: 'Get your own Oracle Audit',
            savingsPotentialFound: 'Savings Potential Found',
            negotiationScript: 'Negotiation Script'
        },
        caseStudy: {
            backToAudit: 'Back to Audit',
            oracleCaseStudy: 'The Oracle Case Study',
            realUserQuestion: 'The Real User Question',
            officialAudit: 'Official Oracle Audit',
            fullReport: 'Full Resolution Report',
            economicImpact: 'Economic Impact',
            startYourAudit: 'Start Your Own Audit',
            moreAudits: 'More Real-World Audits',
            sharingIsCaring: "Sharing is caring. Save someone else's wallet.",
            poweredBy: 'Powered by MyCarCosts Double-Agent Intelligence'
        }
    },
    jarvis: {
        title: 'Jarvis',
        subtitle: 'AI Garage Agent',
        askJarvis: 'Ask Jarvis...',
        typing: 'Jarvis is thinking...',
        safetyWarning: 'Safety Warning',
        repairVerdict: 'Repair Verdict',
        diyFeasibility: 'DIY Feasibility'
    },
    repairMode: {
        oracleStatus: 'Oracle Status: {status}',
        verdictKeep: 'KEEP',
        verdictSell: 'SELL',
        verdictBorderline: 'BORDERLINE'
    }
};

